import { Action } from '@ngrx/store';
import { type } from '../../../util';
import { State } from './flash.reducer';

export const ActionTypes = {
  SHOW: type('[Flash] Show flash'),
  DISMISS: type('[Flash] Dismiss flash'),
};

export class ShowFlash implements Action {
  type = ActionTypes.SHOW;

  constructor(public payload: State) { }
}

export class DismissFlash implements Action {
  type = ActionTypes.DISMISS;
}

export type Actions
  = ShowFlash
  | DismissFlash;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/store/flash.actions.ts